"use client";

import { ChevronRight, ChevronDown, Edit, Trash2, Plus } from "lucide-react";
import { NestedItem } from "../types";

interface NestedItemRowProps {
  nestedItem: NestedItem;
  isExpanded: boolean;
  isSelected: boolean;
  onToggleExpand: () => void;
  onClick: () => void;
  onEdit: () => void;
  onDelete: () => void;
  onAddItem: () => void;
}

export const NestedItemRow = ({
  nestedItem,
  isExpanded,
  isSelected,
  onToggleExpand,
  onClick,
  onEdit,
  onDelete,
  onAddItem,
}: NestedItemRowProps) => {
  const hasItems = nestedItem.items && nestedItem.items.length > 0;

  return (
    <div
      className={`relative border rounded-lg p-3 transition-all group ${
        isSelected
          ? "bg-green-50 border-green-300 shadow-sm"
          : "bg-white border-gray-200 hover:border-gray-300 hover:shadow-sm"
      }`}
    >
      <div className="flex items-center gap-3">
        {/* Expand/Collapse Button */}
        <button
          onClick={onToggleExpand}
          className="w-5 h-5 flex items-center justify-center hover:bg-gray-200 rounded flex-shrink-0 transition-colors"
        >
          {hasItems ? (
            isExpanded ? (
              <ChevronDown className="w-4 h-4 text-gray-600" />
            ) : (
              <ChevronRight className="w-4 h-4 text-gray-600" />
            )
          ) : (
            <div className="w-4 h-4" />
          )}
        </button>

        {/* Nested Item Content */}
        <div className="flex-1 flex items-center gap-2 min-w-0 cursor-pointer" onClick={onClick}>
          <span className={`font-medium text-sm ${isSelected ? "text-green-900" : "text-gray-900"}`}>
            {nestedItem.name}
          </span>

          {/* Item count badge */}
          {hasItems && (
            <span className="text-xs bg-gray-100 text-gray-600 px-2 py-0.5 rounded">
              {nestedItem.items!.length} {nestedItem.items!.length === 1 ? "subject" : "subjects"}
            </span>
          )}
        </div>

        {/* Action Buttons */}
        <div className="flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity flex-shrink-0">
          <button
            onClick={(e) => {
              e.stopPropagation();
              onAddItem();
            }}
            className="p-1.5 hover:bg-green-100 rounded text-green-600 transition-colors"
            title="Add Subject"
          >
            <Plus className="w-4 h-4" />
          </button>
          <button
            onClick={(e) => {
              e.stopPropagation();
              onEdit();
            }}
            className="p-1.5 hover:bg-blue-100 rounded text-blue-600 transition-colors"
            title="Edit Semester"
          >
            <Edit className="w-4 h-4" />
          </button>
          <button
            onClick={(e) => {
              e.stopPropagation();
              onDelete();
            }}
            className="p-1.5 hover:bg-red-100 rounded text-red-600 transition-colors"
            title="Delete Semester"
          >
            <Trash2 className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

